module.exports = __webpack_public_path__ + "static/media/image2.231ba16b.png";